import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseUserAdsComponent } from '../../abstract-components/base-user-ads.component';

@Component({
  selector: 'user-ads-layout',
  standalone: false,
  templateUrl: './user-ads-layout.component.html',
  styleUrl: './user-ads-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAdsLayoutComponent extends BaseUserAdsComponent {}
